import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export default function useManageUserAcknowledgement() {
  const cancelAcknowledgment = async (
    userId: string,
    manualId: string,
    acknowledgementId: string,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexipub/acknowledgements/v1/admin/users/${userId}/manuals/${manualId}/acknowledgements/${acknowledgementId}`;
    await fetcher({
      method: 'delete',
      url,
      body: {},
    })
      .then(() => {
        if (callback) callback();
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    cancelAcknowledgment,
  };
}
